import { makeStyles } from "@material-ui/core/styles";

export const usePaginationStyles = makeStyles((theme) => ({
  root: {
    position: "absolute",
    bottom: "0px",
    left: "0px",
    "& .Mui-selected": {
      backgroundColor: "#fce022",
      color: "black",
      borderRadius: "8px",
      "&:hover": {
        backgroundColor: "#fce022",
      },
    },
    "& > *": {
      marginTop: theme.spacing(1),
      fontSize: "16px",
      "& ul li button": {
        fontSize: "15px",
        fontWeight: "500",
        "&*": {
          backgroundColor: "#3288cd",
        },
      },
    },
  },
}))